import Service, { getCallApiFunction } from '../service'

// 頁首次選單 / 頁尾連結（後台「行銷活動 → 網站選單」設定，shop-api GET /api/v1/site-nav）
// 回應 key 會被轉成 camelCase，labels 的語系 key 也一樣（en-us → enUs），讀取用 methods/siteNav 的 pickSiteNavLabel

export interface SiteNavLink {
  id: number
  /** 預設名稱（繁中） */
  label: string
  /** 其他語系名稱，key 為 camelCase 語系（enUs、zhHk…） */
  labels: Record<string, string>
  /** 站內路徑以 / 開頭（不含語系），外部為 http(s):// */
  url: string
  openNewTab: boolean
  /** 顯示地區 TW / HK / KR / JP / OTHER；空陣列 = 全部 */
  regions: string[]
  gtmEvent: string
}

export interface SiteNavColumn {
  id: number
  label: string
  labels: Record<string, string>
  regions: string[]
  links: SiteNavLink[]
}

export interface FetchSiteNavResponse {
  header: SiteNavLink[]
  footer: SiteNavColumn[]
}

class FetchSiteNavApi extends Service {
  constructor() {
    super()
    this.name = 'FETCH_SITE_NAV'

    this.config = {
      url: `/v1/site-nav`,
      method: 'GET',
    }
  }
}

export const fetchSiteNav = (): Promise<FetchSiteNavResponse> => getCallApiFunction(new FetchSiteNavApi())
